import React from 'react';
import { XCircle } from 'lucide-react';
export function FailedAttempts() {
  const attempts = ['El cardio eterno solo dispara tu cortisol y te inflama más las articulaciones.', 'Las dietas de pasar hambre destruyen tu testosterona y te dejan sin fuerza para rendir en el trabajo.', 'Los suplementos "quemagrasa" son solo cafeína cara que te da taquicardia pero no toca tu grasa visceral.', 'Contar calorías es para contadores, no para hombres que quieren disfrutar de la vida y un buen BBQ.'];
  return <section className="bg-dark-surface text-white py-20 px-4 md:px-8" data-id="element-2">
      <div className="max-w-4xl mx-auto" data-id="element-3">
        <h2 className="font-oswald text-3xl md:text-5xl font-bold mb-12 text-center uppercase" data-id="element-4">
          Por qué lo que intentaste{' '}
          <span className="text-red-500" data-id="element-5">NO FUNCIONÓ</span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-6">
          {attempts.map((attempt, index) => <div key={index} className="flex items-start bg-dark-bg p-6 rounded-lg border border-gray-800" data-id="element-7">
              <XCircle className="w-8 h-8 text-red-500 mr-4 flex-shrink-0 mt-1" data-id="element-8" />
              <p className="font-inter text-gray-300 text-lg" data-id="element-9">{attempt}</p>
            </div>)}
        </div>
      </div>
    </section>;
}